const _excluded = ["children", "className", "contentClassName", "showFooter", "data-testid", "onClose", "scrollContainerRef"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React, { useContext, useState } from 'react';
import { createPortal } from 'react-dom';
import cn from 'classnames';
import { CloseButton } from "../CloseButton";
import { Typography } from "../Typography";
import styles from "./FullPageModal.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const HeaderStartContext = /*#__PURE__*/React.createContext(null);
const HeaderEndContext = /*#__PURE__*/React.createContext(null);
const FooterEndContext = /*#__PURE__*/React.createContext(null);
const FooterStartContext = /*#__PURE__*/React.createContext(null);
const FooterCenterContext = /*#__PURE__*/React.createContext(null);
export function FullPageModal(props) {
  const {
      children,
      className,
      contentClassName,
      showFooter,
      ['data-testid']: testid,
      onClose,
      scrollContainerRef
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const [headerStartEl, setHeaderStartEl] = useState(null);
  const [headerEndEl, setHeaderEndEl] = useState(null);
  const [footerStartEl, setFooterStartEl] = useState(null);
  const [footerEndEl, setFooterEndEl] = useState(null);
  const [footerCenterEl, setFooterCenterEl] = useState(null);
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({}, rest), {}, {
    className: cn(styles.root, className),
    "data-testid": testid,
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.header,
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: "h5",
        weight: "normal",
        ref: setHeaderStartEl,
        "data-testid": testid && testid + '-header-start'
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.headerEnd,
        children: [/*#__PURE__*/_jsx("div", {
          ref: setHeaderEndEl
        }), /*#__PURE__*/_jsx(CloseButton, {
          skin: "transparent",
          "data-testid": testid && testid + '-close-btn',
          onClick: onClose
        })]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: cn(styles.content, contentClassName),
      ref: scrollContainerRef,
      "data-testid": testid && "".concat(testid, "-content"),
      children: /*#__PURE__*/_jsx(HeaderStartContext.Provider, {
        value: headerStartEl,
        children: /*#__PURE__*/_jsx(HeaderEndContext.Provider, {
          value: headerEndEl,
          children: /*#__PURE__*/_jsx(FooterStartContext.Provider, {
            value: footerStartEl,
            children: /*#__PURE__*/_jsx(FooterEndContext.Provider, {
              value: footerEndEl,
              children: /*#__PURE__*/_jsx(FooterCenterContext.Provider, {
                value: footerCenterEl,
                children: children
              })
            })
          })
        })
      })
    }), showFooter && /*#__PURE__*/_jsxs("div", {
      className: styles.footer,
      children: [/*#__PURE__*/_jsx("div", {
        ref: setFooterStartEl
      }), /*#__PURE__*/_jsx("div", {
        ref: setFooterCenterEl
      }), /*#__PURE__*/_jsx("div", {
        className: styles.footerEnd,
        ref: setFooterEndEl
      })]
    })]
  }));
}
const useSlot = (context, children) => {
  const element = useContext(context);
  return element ? /*#__PURE__*/createPortal(children, element) : null;
};

/** Renders its children inside the headerStart slot. */
export const FullPageModalHeaderStart = p => useSlot(HeaderStartContext, p.children);

/** Renders its children inside the headerEnd slot. */
export const FullPageModalHeaderEnd = p => useSlot(HeaderEndContext, p.children);

/** Renders its children inside the footerStart slot. */
export const FullPageModalFooterStart = p => useSlot(FooterStartContext, p.children);

/** Renders its children inside the footerCenter slot. */
export const FullPageModalFooterCenter = p => useSlot(FooterCenterContext, p.children);

/** Renders its children inside the footerEnd slot. */
export const FullPageModalFooterEnd = p => useSlot(FooterEndContext, p.children);
FullPageModal.HeaderStart = FullPageModalHeaderStart;
FullPageModal.HeaderEnd = FullPageModalHeaderEnd;
FullPageModal.FooterStart = FullPageModalFooterStart;
FullPageModal.FooterEnd = FullPageModalFooterEnd;
FullPageModal.FooterCenter = FullPageModalFooterCenter;